<div class="row mt-3 mb-5 mx-3 mx-md-0">
  <div class="col-12 col-md-10 offset-md-1 justify-content-center">

    <mat-card class="rounded-0 border">
      <mat-card-title>
        <h2 class="color-blue-cat">Mis Solicitudes</h2>
      </mat-card-title>
      <mat-card-content>
    
        <mat-tab-group class="mt-n2" [selectedIndex]="selectedIndex">
          <mat-tab label="Pago en línea">
            <!---Formulario para seleccionar una solicitud--->
            <form class="mt-3" [formGroup]="seleccionarSolicitudForm" (ngSubmit)="requestSolicitud()" *ngIf="!loading">
              <div class="row">
                <mat-form-field class="col-12 col-md-6">
                  <mat-label>Seleccione una Solicitud</mat-label>
                  <mat-select name="solicitud" formControlName="idSolicitud">
                    <mat-option *ngFor="let solicitud of solicitudes" [value]="solicitud.idTipoSolicitud">
                      {{solicitud.solicitud}} <small class="text-muted text-italic" *ngIf="solicitud.idProducto == 0">(Gratuito)</small>
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="solicitudNoValida">*Campo requerido</mat-error>
                </mat-form-field>

                <div class="col-12 col-md-6" *ngIf="!solicitudNoValida">
                  <dt>Descripción de la solicitud</dt>
                  <dd>{{solicitudesTemp[0]?.descripcion}}</dd>
                </div>
              </div>                  

              <div class="text-right">
                <button class="btn-blue-cat" type="submit" mat-raised-button>Siguiente</button>
              </div>
            </form>
            <!---End Formulario para seleccionar una solicitud--->
          </mat-tab>

          <mat-tab label="Mis Solicitudes">

            <!--Input para filtrar datos-->
            <div class="row mt-3">
              <mat-form-field class="col-12 col-md-4">
                <mat-label>Filtrar</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar por Folio o Estatus" #input>
              </mat-form-field>
            </div>

            <!---Tabla Solicitudes-->
            <table mat-table [dataSource]="dataSource" class="w-100 table-hover table-responsive-md mt-3">

              <!--Columna Folio-->
              <ng-container matColumnDef="folio">
                <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>Folio</th>
                <td mat-cell *matCellDef="let element">{{element.folio}}</td>
              </ng-container>
            
              <!--Columna Tipo de Tramite-->
              <ng-container matColumnDef="tipoTramite">
                <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>Tipo de trámite</th>
                <td mat-cell *matCellDef="let element">{{element.idTipoSolicitud}}</td>
              </ng-container>

              <!--Columna Fecha de solicitud-->
              <ng-container matColumnDef="fechaSolicitud">
                <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>Fecha de solicitud</th>
                <td mat-cell *matCellDef="let element">{{element.fechaSolicitud | date: 'medium'}}</td>
              </ng-container>

              <!--Columna Estatus-->
              <ng-container matColumnDef="estatus">
                <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>Estatus</th>
                <td mat-cell *matCellDef="let element">{{element.estatus}}</td>
              </ng-container>

              <!--Columna Fecha de atención-->
              <ng-container matColumnDef="fechaAtencion">
                <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>Fecha de atención</th>
                <td mat-cell *matCellDef="let element" [ngClass]="{'text-italic text-muted': element.fechaAtencion == null}">{{element.fechaAtencion == null ? "Pendiente por atender": element.fechaAtencion | date: 'medium'}}</td>
              </ng-container>              
            
              <!--Columna Opciones -->
              <ng-container matColumnDef="opciones">
                <th class="bg-blue-cat text-white" mat-header-cell *matHeaderCellDef>Opciones</th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button color="primary" (click)="openDialog(element.idSolicitud)" matTooltipPosition="above" matTooltip="Ver detalles">
                    <mat-icon>remove_red_eye</mat-icon>
                  </button>
                </td>
              </ng-container>
            
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>                        
              
            </table>
            <!---End Tabla Solicitudes-->

            <!--Div a mostrar cuando estén cargando los datos-->
            <div class="alert alert-light text-center" *ngIf="loading">
              <p class="d-flex justify-content-center">
                <mat-spinner></mat-spinner>
              </p>
            </div>
            
            <!---Div a mostrar cuando no encuentre coincidencias--->
            <div class="alert" role="alert" *ngIf="!loading && dataSource.filteredData.length === 0">
              No se han encontrado resultados para: {{input.value}}
            </div>

            <!--Div a mostrar cuando no haya datos-->
            <div class="alert alert-info text-center mt-1" *ngIf="dataSource.data.length == 0">
              <p class="d-flex justify-content-center"><mat-icon class="icon-material">info</mat-icon></p>
              <h4 class="alert-heading">No tienes solicitudes para mostrar</h4>
            </div>

            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

          </mat-tab>
        </mat-tab-group>
        
      </mat-card-content>
    </mat-card>

  </div>
</div>